module.exports = __webpack_public_path__ + "static/media/edit_no_margin.d4d91590.svg";